import { ActionType } from '../enums';
import { Vendor } from './vendor.model';
import { MachineServiceStatus } from '../enums/MachineServiceStatus.enum';
import { ModelGroup } from './model-group.model';
import { TransportPurpose } from '../../app/base/entities/transport.interface';

interface completedTrackedAction  {
    actionType: ActionType;
    driver: string;
    completedAt: string;
    machineInternalId: string;
}

/**
 * @deprecated Remove once QDrive uses the instance DTO from the new backend.
 */
export interface Machine {
    id: number;
    internalId: string | null;
    blockedReason: string | null;
    brandType: string;
    fleetNumber: string;
    serialNumber: string;
    displayName: string;
    icon: string;
    rasterLocation: string | null;
    currentLocation: string | null;
    type: SupportedMachineEquipmentType;
    modelGroup: ModelGroup | null;
    purpose: TransportPurpose;
    status: MachineServiceStatus | null;
    vendor: Vendor;
    vendorId?: string | null;
    engineType?: string | null;
    /**
     * The equipment detail of a machine, but translated into the language of the driver.
     * See DriverService#getDriverData in the backend.
     */
    equipmentDetail?: string | null;
    /**
     * The equipment detail of a machine, as it comes from object management.
     */
    equipmentDetailNotTranslated?: string | null;
    grossVehicleWeight?: string | null;
    minimumTransportHeight?: string;
    minimumTransportWidth?: string;
    minimumTransportLength?: string;
    lastExecutedAction?: completedTrackedAction | null;
    equipmentDetailTranslationLabel?: string | null;
    /**
     *  This category label is used to identify "Truck Mounted Boomlift" and it should all covered for all rental machine,
     *  however when used for customer transport might able to run in trouble which may not always provide it.
     */
    equipmentDetailCategoryLabel?: string | null;

}

export function getMachineObjectIdAndDisplayName(machine: Machine) {
    if (!machine.displayName || machine.fleetNumber === machine.displayName) {
        return machine.fleetNumber;
    } else {
        // Using a slash instead of braces (like machine card) because the former is more readable,
        return `${machine.fleetNumber} / ${machine.displayName}`;
    }
}

/**
 * @deprecated Use {@link EquipmentType} instead.
 */
export enum SupportedMachineEquipmentType {
    ATTACHMENT = 'attachment',
    MACHINE = 'machine',
    MISC = 'misc'
}
